import React from 'react'
import filterUsers from '../../../../../helpers/users/manageUsers/filterUsers'
import { InfoCard } from './'
import sortByPropText from '../../../../../helpers/content/manageSets/sortByPropText'
import notUserQ from '../../../../../helpers/users/manageUsers/notUserQ';

export default function InfoCards(
  { records,
    filter,
    recordType,
    actionId,
    history,
    search,
    user,
    students, }) {
  const sortTerm = notUserQ(recordType) ? (recordType === 'class' ? 'period' : 'name') : 'lastName'
  const filteredRecordList = sortByPropText(filterUsers(records, filter, recordType), sortTerm)
  return (
    <ul className='info-cards'>
      {filteredRecordList.map(record =>
        <InfoCard
          record={record}
          recordType={recordType}
          actionId={actionId}
          key={`ic${record.id}`}
          search={search}
          history={history}
          user={user}
          students={students}
        />
      )}
    </ul>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/InfoCards.js